import { render, staticRenderFns } from "./xieYi.vue?vue&type=template&id=7cfd447d"
import script from "./xieYi.vue?vue&type=script&lang=js"
export * from "./xieYi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports